import React, { FC, useEffect, useState, useRef } from "react";
import QRCode from 'qrcode.react';
import Cookies from "js-cookie";
import { fetchUser, getPackage, fetchSignatures, getGuardiansByActivityId, sendAppointmentTime, history, moveStudentPhoto, getPhotoOrderDetail, orderEdit, getAllSelector, selectionRecordList, addOrder, selectionRecordEdit, getStudentByClassId, selectAllOrderPhotos, getdatalist, getMaxMinPhoto, addparent, isboundServiceUser, boundServiceUser, parentandstuunbind, getSignaturesTicket, fetchExternalUser, userinfo, getqywxguardian, photos, getfilmmaker, getschooloptionsbyactivityid, getBindStudentList, OrderSuccess, deleteByTradeSn, editByTradeSn, refund } from "../../api";
import { Divider, Spin } from "antd";
import { jsSdk } from "../../index";
import apis from '../../lib/jsSdk/apis';
import ExternalUser from "./components/ExternalUser";
import ExternalChat from "./components/ExternalChat";
import Action from "./components/Action";
import MicroAppComponent from "./components/MicroAppComponent";
import type { MenuProps } from 'antd';
import { BorderBottomOutlined } from "@ant-design/icons";
import { Input, Cascader, Menu, Dropdown, Space, Drawer, Modal, Radio, AutoComplete, Button, Table, Popconfirm, Checkbox, Select } from 'antd';
import type { RadioChangeEvent } from 'antd';
import { DownOutlined, SmileOutlined, CheckOutlined } from '@ant-design/icons';
import { error } from "console";
import { setTimeout } from "timers";
const Home: FC = () => {
  const [isLogin, setisLogin] = useState<boolean>(false);//是否登录
  const [photoIsShow, setphotoIsShow] = useState<boolean>(false);//选片是否显示
  const [loading, setLoading] = useState<boolean>(false);
  const [menName, setMenName] = useState<string>('请选择');//选择身份
  const [chooseIdentity, setchooseIdentity] = useState<string>('请选择');
  const [user, setUser] = useState<any>('');//客服企业微信id
  const [serviceInfo, setserviceInfo] = useState<any>('');//客服数据库信息
  const [externalUserId_, setexternalUserId_] = useState<string>('');//客服数据库信息
  const [qrValue, setQrValue] = useState<any>('https://webr.tangsuankeji.com?activityId=12&userId=62&role=user&name=仝仝仝&cid=53&studentId=3670');;//二维码数据
  const [filmSelectorIndex, setFilmselectorIndex] = useState<any>(0);//本校选片师/全部选片师下标
  const [ourSchoolSelector, setourSchoolSelector] = useState<any>([])//本校选片师
  const [allSelector, setallSelector] = useState<any>([//全部选片师
    // { name: '全部选片师1', index: 1, state: '对话中' },
  ])
  const [selectionRecord, setselectionRecord] = useState<any>([])//选片记录
  const [userInFo, setuserInFo] = useState<any>({})//客户信息本地缓存
  const [userData, setuserData] = useState<any>(null)//页面数据本地缓存
  const [qywxguardian, setqywxguardian] = useState<any>(null)//数据库用户信息
  // const [selectedFilm, setselectedFilm] = useState<any>([])//已选照片
  const [newNotSelectedFilm, setnewNotSelectedFilm] = useState<any>([])//只显示的5张照片
  const [notSelectedFilm, setnotSelectedFilm] = useState<any>([])//全部活动照片
  const [SelectedFilm, setSelectedFilm] = useState<any>([])//选择照片
  const [isqywxguardian, setisqywxguardian] = useState<any>(false)//是否显示关联孩子按钮
  const [Msg, setMsg] = useState<any>('')//显示msg
  const [options, setoptions] = useState<any>([])//年级树形结构数据
  const [drawer_, setdrawer_] = useState<any>(false);//关联孩子弹出框的显示
  const [creat_order, setcreat_order] = useState<any>(false);//创建订单弹出框的显示
  const [orderLoading, setorderLoading] = useState<any>(false);//创建订单弹出框的加载loading
  const [creat_orderList, setcreat_orderList] = useState<any>(false);//创建在线选片弹出框的显示
  const [Package_show, setPackage_show] = useState<any>(false);//套餐详情弹出框的显示
  const [orderListLoading, setorderListLoading] = useState<any>(false);//创建在线选片弹出框的加载loading
  const [Package_, setPackage_] = useState<any>([]) //接口获取的套餐
  const [physicalItem, setphysicalItem] = useState<any>([]) ////接口获取的实物单品
  const [filmSingleItem, setfilmSingleItem] = useState<any>([]) ////接口获取的底片单品
  const [storagePackage_, setstoragePackage_] = useState<any>([]) //存储勾选套餐
  const [storagephysicalItem, setstoragephysicalItem] = useState<any>([]) //存储勾选实物单品
  const [storagefilmSingleItem, setstoragefilmSingleItem] = useState<any>([]) //存储勾选底片单品
  const [baseUrl, setbaseUrlm] = useState<any>('http://tswl.school.tangsuankeji.com/') //照片查看域名地址
  const Package_Click = (checkedValues: any) => {//套餐点击
    setstoragePackage_(checkedValues)
    let data: any = Package_.filter((item: any) => item.id == checkedValues[checkedValues.length - 1])
    console.log(data)
    if (data.length > 0) {
      let num = data[0].enrollmentNum ? data[0].enrollmentNum : 0;
      setmax_photo(num)
    }
  };
  const physicalItemClick = (checkedValues: any) => {//实物单品点击
    setstoragephysicalItem(checkedValues)
    let data: any = physicalItem.filter((item: any) => item.id == checkedValues[checkedValues.length - 1])
    console.log(data)
    if (data.length > 0) {
      let num = data[0].enrollmentNum ? data[0].enrollmentNum : 0;
      setmax_photo(num)
    }
  };
  const filmSingleItemClick = (checkedValues: any) => {//底片单品点击
    setstoragefilmSingleItem(checkedValues)
    let data: any = filmSingleItem.filter((item: any) => item.id == checkedValues[checkedValues.length - 1])
    console.log(data)
    if (data.length > 0) {
      let num = data[0].enrollmentNum ? data[0].enrollmentNum : 0;
      setmax_photo(num)
    }
  };
  //关闭在线选片
  const onCheckCloseList = () => {
    setformData({ ...formData, name: null, chooseIdentity: '', grade: '', phone: '', parentName: '' })
    setcreat_orderList(false);
    setorderListLoading(false);
    setSelectedPhotos([]);
  };
  //关闭套餐详情
  const onshowCloseList = () => {
    setPackage_show(false);
  };
  //关闭创建订单
  const onCheckClose = () => {
    setcreat_order(false);
    setorderLoading(false);
    setstoragePackage_([]);
    setstoragephysicalItem([]);
    setstoragefilmSingleItem([]);
  };
  const isOrderList = () => {
    if (Package_.length == 0 && physicalItem.length == 0 && filmSingleItem.length == 0) {
      alert('暂无套餐')
    } else {
      setcreat_order(true)
    }
  };
  //创建订单
  const [selectStudent, setselectStudent] = useState(null); //创建订单选择的孩子id
  const [selectStudentName, setselectStudentName] = useState(null); //选择的孩子姓名
  const [max_photo, setmax_photo] = useState<any>(0); //最大入册张数
  const [selectStudentList, setselectStudentList] = useState([]); //孩子列表
  const selectStudentonChange = (e: RadioChangeEvent) => {
    console.log('radio checked', e.target);
    setselectStudent(e.target.value);
    let data: any = selectStudentList.filter((item: any) => item.value == e.target.value)
    if (data.length > 0) {
      setselectStudentName(data[0].label)
    }
  };
  const saveOrderList = () => {
    console.log(storagePackage_, storagephysicalItem, storagefilmSingleItem)
    if (storagePackage_.length == 0 && storagephysicalItem.length == 0 && storagefilmSingleItem.length == 0) {
      alert('请选择套餐')
    } else {
      setorderLoading(true);//开启加载
      console.log('打印客服id', serviceInfo)
      //请求创建订单接口
      addOrder({ maxPhoto: max_photo, studentName: selectStudentName, studentId: selectStudent, comboIds: storagePackage_, goodsIds: [...storagephysicalItem, ...storagefilmSingleItem], createBy: serviceInfo.id || serviceInfo.userId || '', memberId: qywxguardian.guardianId, activityId: qywxguardian.activityId }).then(res => {
        // alert('res0:' + JSON.stringify(res))
        if (res.code == 0) {
          alert('订单创建成功')
          setorderLoading(false);//关闭加载
          setcreat_order(false);//关闭弹出框
          setstoragePackage_([])//清除选择的套餐
          setstoragephysicalItem([])//清除选择的实物单品
          setstoragefilmSingleItem([])//清除选择的底片单品
          //刷新订单列表
          updateList();
        } else {
          alert(res.msg)
        }
      })
    }
  };
  const [bing, setbing] = useState<boolean>(false)//是否显示绑定按钮
  const [school, setschool] = useState<string>('')//关联孩子按钮点击的时候将学校名字赋值上去 不然组件会销毁
  const [dataSource, setdataSource] = useState<any>([])//已绑定孩子列表
  const [formData, setformData] = useState<any>({//表单数据
    name: null,//姓名
    studentId: '',//学生id
    chooseIdentity: '',//身份
    grade: '',//所在班级
    schoolLocation: '',//所在学校
    activityId: '',//活动id
  })
  const [MaxSelectable, setMaxSelectable] = useState<any>(0)//最大入册数量
  const [MinSelectable, setMinSelectable] = useState<any>(0)//最小入册数量
  //下载图片
  const linkRef = useRef<any>(null);
  const handleDownload = () => {
    linkRef.current.click();
  };
  const [selectedPhotos, setSelectedPhotos] = useState<any>([]);//选中的照片
  const [currentPhoto, setCurrentPhoto] = useState<any>(null); //照片放大
  const [OPTIONSList_, setOPTIONSList_] = useState<any>([]);//活动列表
  const [studentList_, setstudentList_] = useState<any>([]);//学生列表
  const [student_, setstudent_] = useState<any>([]);//学生列表
  const handleCheckboxChange = (event: any, photoId: any) => {//照片点击
    if (event.target.checked) {
      // 如果多选框被选中，将照片ID添加到数组中
      setSelectedPhotos([...selectedPhotos, photoId]);
    } else {
      // 如果多选框被取消选中，从数组中移除照片ID
      setSelectedPhotos(selectedPhotos.filter((id: any) => id !== photoId));
    }
  }
  //移动照片全选
  const [selectAllState, setselectAllState] = useState<any>(true);//活动列表
  const selectAll = () => {//全选
    if (selectAllState) {
      let newArray: any = []; // 获取所有照片ID
      selectStudentInfo.photosUrl.forEach((item: any) => {
        newArray.push(item)
      })
      // 如果多选框被选中，将照片ID添加到数组中
      setSelectedPhotos(newArray);
      setselectAllState(false);
    } else {
      setSelectedPhotos([]);
      setselectAllState(true);
    }
  }

  //照片提交
  const photoHandle = () => {
    console.log(selectedPhotos, 'selectedPhotos')
    console.log('stduentInfo', stduentInfo)
    if (selectedPhotos.length == 0) {
      alert(`请选择照片`)
    } else {
      if (stduentInfo.length > 0) {
        setorderListLoading(true);
        moveStudentPhoto({ activityId: stduentInfo[0].activityId, schoolId: stduentInfo[0].cid, studentId: stduentInfo[0].id, photoUrlList: selectedPhotos }).then((res: any) => {
          console.log('移动照片', res)
          if (res.code == 0) {
            setorderListLoading(false);
            window.location.reload();
          }
        })
      }
    }
  }
  //图片放大
  const [urlIndex, seturlIndex] = useState<any>(0); //当前图片索引
  const [AllurlIndex, setAllurlIndex] = useState<any>(0); //所有图片总数
  const handlePhotoClick = (photo: any, index: any, index1: any) => {
    let photo_url = photo.replace('compressed_', '')
    console.log(photo, photo_url)
    setCurrentPhoto(photo_url);
    seturlIndex(index1); //设置当前图片索引
    setAllurlIndex(userData.studentInfo[index].photosUrl.length); //所有图片总数
  };
  //套餐放大
  const [currentPhoto1, setCurrentPhoto1] = useState<any>(null); //套餐详情放大
  const [urlIndex1, seturlIndex1] = useState<any>(-1); //当前图片索引
  const handlePhotoClick1 = (photo: any, index: any) => {
    let photo_url = photo.replace('compressed_', '')
    setCurrentPhoto1(photo_url);
    // setCurrentPhoto1(photo);
    if (index !== -1) {
      seturlIndex1(index); //设置当前图片索引
    }
  };
  //照片移动放大
  const [currentPhoto2, setCurrentPhoto2] = useState<any>(null); //套餐详情放大
  const [urlIndex2, seturlIndex2] = useState<any>(-1); //当前图片索引
  const handlePhotoClick2 = (photo: any, index: any) => {
    let photo_url = photo.replace('compressed_', '')
    setCurrentPhoto2(photo_url);
    // setCurrentPhoto2(photo);
    if (index !== -1) {
      seturlIndex2(index); //设置当前图片索引
    }
  };
  //关联孩子点击
  const showDrawer = () => {
    setdrawer_(true);
    setformData({ ...formData, schoolLocation: school })
    //重新请求孩子列表
    if (qywxguardian) {
      getBindStudentList({ id: qywxguardian.guardianId, pageSize: 999, currentPage: 1 }).then(res => {
        if (res.code == 0 && res.data) {
          setdataSource(res.data.records)
        }
      })
    }
  };
  //弹出框关闭 
  const onClose = () => {
    console.log('onClose');
    setdrawer_(false);
    setbing(false);
    setformData({ ...formData, name: null, chooseIdentity: '', grade: '', phone: '', parentName: '' })
    console.log(formData, 'formData')
  };
  const container = {
    width: '100%',
    margin: 'auto',
    border: '1px solid #ccc',
    padding: '10px'
  }
  const section = {
    marginBottom: '10px',
    background: '#fafafb',
    borderRadius: '5px',
    padding: '5px'
  }
  const btn_bottom = {
    display: 'flex',
    marginTop: '5px',
  }
  const filmSelector0 = {
    display: 'flex',
    background: '#fafafb',
    borderRadius: '5px',
    padding: '5px',
    justifyContent: 'space-between'
  }
  const filmSelector1 = {
    display: 'flex',
    marginBottom: '10px',
    background: '#fafafb',
    borderRadius: '5px',
    padding: '5px',
  }
  const filmSelectorbtn_right = {
    marginRight: '8px',
    fontSize: '15px',
    cursor: 'pointer',
  }
  const filmSelectorbtn_right_bottom = {
    marginRight: '8px',
    fontSize: '15px',
    borderBottom: '2px solid blue',
    cursor: 'pointer',
  }
  const [identityList, setidentityList] = useState<any>([ //身份选择list
    {
      label: '妈妈',
      value: '妈妈',
    },
    {
      label: '爸爸',
      value: '爸爸',
    },
    {
      label: '奶奶',
      value: '奶奶',
    },
    {
      label: '爷爷',
      value: '爷爷',
    },
    {
      label: '外婆',
      value: '外婆',
    },
    {
      label: '外公',
      value: '外公',
    },
    {
      label: '其他',
      value: '其他',
    }
  ])
  //已绑定孩子
  const columns: any = [
    {
      title: '学生姓名',
      dataIndex: 'studentName',
      key: 'studentName',
      align: 'center'
    },
    {
      title: '活动名称',
      dataIndex: 'activityName',
      key: 'activityName',
      align: 'center'
    },
    {
      title: '操作',
      dataIndex: 'operation',
      render: (_: any, record: any) =>
        dataSource.length >= 1 ? (
          <Popconfirm title="您确定解除绑定吗?" onConfirm={() => handleDelete(record.studentId)}>
            <a>解绑</a>
          </Popconfirm>
        ) : null,
    },
  ];
  const handleDelete = (studentId: any) => {
    parentandstuunbind({ parentId: qywxguardian.guardianId, studentId: studentId }).then(res => {
      if (res.code == 0) {
        alert('解绑成功')
        //重新请求孩子列表
        getBindStudentList({ id: qywxguardian.guardianId, pageSize: 999, currentPage: 1 }).then(res => {
          if (res.code == 0 && res.data) {
            setdataSource(res.data.records)
          }
        })
      } else {
        alert(res.msg)
      }
    })
    // setdataSource(dataSource.filter((item: any) => item.studentId !== studentId));
  };
  //截取身份
  const intercept = (title: any) => {
    if (title) {
      let data = title.split('的')[1]
      if (data) {
        let new_data = data.split('-')[0]
        return new_data
      }
    }
  };
  //时间戳转换
  const formatDate = (timestamp: any) => {
    if (timestamp) {
      const date = new Date(timestamp); // 注意时间戳通常是以秒为单位，需要乘以1000转换为毫秒
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');
      const second = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    }
  };
  //控制绑定按钮
  const binding = () => {
    setbing(true)
  }
  //选择班级
  const onChange = (value: any, label: any) => {
    console.log(value, label)
    setformData({ ...formData, grade: label })
    console.log(formData)
    console.log(value[2])
    // getStudentByClassId({ classId: value[2] }).then(res => {
    //   if (res.code == 0) {
    //     setstudentList_(res.data)
    //   }
    // })
  };
  //提交按钮
  const handle = function () {
    console.log(formData, 'formData')
    console.log(stduentInfo, 'stduentInfo')
    if (!formData.name) { alert('请输入姓名'); return false }
    if (!formData.chooseIdentity) { alert('请选择身份'); return false }
    if (stduentInfo.length > 0) {
      let params = {
        externalUserid: externalUserId_,
        activityId: formData.activityId,
        cid: stduentInfo[0].cid,
        studentName: formData.name,
        studentId: formData.studentId,
        parentName: stduentInfo[0].gradeName + '-' + stduentInfo[0].className + '-' + formData.name + '的' + formData.chooseIdentity + '-' + selectedItems,
        userId: user
      }
      try {
        addparent(params).then((res: any) => {
          if (res.code == 0) {
            alert('绑定成功')
            //关闭添加孩子信息窗口
            setbing(false)
            //刷新页面
            window.location.reload();
            //重新请求孩子列表
            getBindStudentList({ id: qywxguardian.guardianId, pageSize: 999, currentPage: 1 }).then(res => {
              if (res.code == 0 && res.data) {
                setdataSource(res.data.records);
              }
            })
          } else {
            alert(res.msg)
          }
        })
      } catch (e) { }
    }
  }
  //选片师按钮点击
  const filmSelectorBtnClick = (num: any): void => {
    setFilmselectorIndex(num)
  }
  //在线选片卡片
  const sendMissage = async () => {
    if (!qywxguardian) {
      alert('未查到家长信息')
    } else if (!userInFo) {
      alert('未查到客服信息')
    } else if (!userData || userData && userData.studentInfo.length == 0) {
      alert('未查到学生信息')
    } else {
      let studentList: any = JSON.stringify(selectStudentList);
      const signaturesRes = await fetchSignatures();
      console.log('signaturesRes拿到签名', signaturesRes)
      console.log('链接', `/schools/phoneSelection/phoneSelection.html?activityId=${qywxguardian.activityId}&userId=${qywxguardian.guardianId}&studentList=${studentList}`)
      if (signaturesRes) {
        wx.invoke('sendChatMessage', {
          msgtype: "miniprogram",
          miniprogram: {
            appid: "wx5bc1a7d97b54067d",//小程序的appid，企业已关联的任一个小程序
            title: "邀您选片", //小程序消息的title
            imgUrl: "https://school.tangsuankeji.com/static/upload/flies/1733468169804%E3%80%90tswl%E3%80%91tsxm.jpg",//小程序消息的封面图。必须带http或者https协议头，否则报错 $apiName$:fail invalid imgUrl
            //在线选片
            page: `/schools/phoneSelection/phoneSelection.html?activityId=${qywxguardian.activityId}&userId=${qywxguardian.guardianId}&studentList=${studentList}`,
          }
        }, function (res) {
          console.log(res, '发送成功')
          if (res.err_msg == 'sendChatMessage:ok') {
            //发送成功
          }
        });
      }
    }
  }
  //邀请预约卡片
  const inviteAppointment = async () => {
    if (!qywxguardian) {
      alert('未查到家长信息')
    } else {
      console.log(`/schools/bookShooting/bookShooting.html?activityId=${qywxguardian.activityId}&externalUserid=${externalUserId_}`)
      const signaturesRes = await fetchSignatures();
      if (signaturesRes) {
        wx.invoke('sendChatMessage', {
          msgtype: "miniprogram",
          miniprogram: {
            appid: "wx5bc1a7d97b54067d",//小程序的appid，企业已关联的任一个小程序
            title: "邀您预约", //小程序消息的title
            imgUrl: "https://school.tangsuankeji.com/static/upload/flies/1733468169804%E3%80%90tswl%E3%80%91tsxm.jpg",//小程序消息的封面图。必须带http或者https协议头，否则报错 $apiName$:fail invalid imgUrl
            //预约时间
            page: `/schools/bookShooting/bookShooting.html?activityId=${qywxguardian.activityId}`,
          }
        }, function (res) {
        });
      }
    }
  }
  //是否预约
  const [reservationList, setreservationList] = useState([{ id: 1, name: '已预约' }, { id: 0, name: '未预约' }]); //预约方式
  const [isreservation, setisreservation] = useState<any>(null); //是否预约
  class SelectFilmSelector88 extends React.Component {
    handleChange_88 = (value: any, option: any) => {
      console.log(value, isFilmSelection)
      setisreservation(value)
      setselectMassPosting([])//清空群发列表
      setisSelectAll(true)//全选关闭
      if (isFilmSelection != null) {
        setCheckboxOptions(keepCheckboxOptions.filter((item: any) => item.isBooked == value && item.isSelected == isFilmSelection))
      } else {
        setCheckboxOptions(keepCheckboxOptions.filter((item: any) => item.isBooked == value))
      }
    };
    render() {
      return (
        <Select
          placeholder="是否预约"
          onChange={this.handleChange_88}
          showSearch
          value={isreservation}
          style={{ width: '30%', marginRight: '10px' }}
        >
          {reservationList.map((item: any) => (
            <Select.Option key={item.id} value={item.id}>
              {item.name}
            </Select.Option>
          ))}
        </Select>
      );
    }
  }
  //重置
  const Init = () => {
    setCheckboxOptions(JSON.parse(JSON.stringify(keepCheckboxOptions)))
    setFilmSelection(null)
    setisreservation(null)
    setselectMassPosting([])//清空群发列表
    setisSelectAll(true)//全选关闭
  }
  //已选片
  const [FilmSelectionList, setFilmSelectionList] = useState([{ id: 1, name: '已选片' }, { id: 0, name: '未选片' }]); //选片方式
  const [isFilmSelection, setFilmSelection] = useState<any>(null); //是否选片
  class SelectFilmSelector99 extends React.Component {
    handleChange_99 = (value: any, option: any) => {
      console.log(value, isreservation)
      setFilmSelection(value)
      setselectMassPosting([])//清空群发列表
      setisSelectAll(true)//全选关闭
      if (isreservation != null) {
        setCheckboxOptions(keepCheckboxOptions.filter((item: any) => item.isBooked == isreservation && item.isSelected == value))
      } else {
        setCheckboxOptions(keepCheckboxOptions.filter((item: any) => item.isSelected == value))
      }
    };
    render() {
      return (
        <Select
          placeholder="是否选片"
          onChange={this.handleChange_99}
          showSearch
          value={isFilmSelection}
          style={{ width: '30%' }}
        >
          {FilmSelectionList.map((item: any) => (
            <Select.Option key={item.id} value={item.id}>
              {item.name}
            </Select.Option>
          ))}
        </Select>
      );
    }
  }
  //邀请预约(群发)
  const [keepCheckboxOptions, setkeepCheckboxOptions] = useState<any>([]);//留存所有数据
  const [CheckboxOptions, setCheckboxOptions] = useState<any>([]);//选择的群发人员{ label: '幼儿园-小班-李小黑的爸爸1', value: '幼儿园-小班-李小黑的爸爸1' },
  const [isSelectAll, setisSelectAll] = useState<any>(true) //是否全选
  const [selectMassPosting, setselectMassPosting] = useState<any>([]) //存储选择的群发人员
  //全选
  const SelectAll = () => {
    if (isSelectAll) {
      console.log('全选')
      //多选
      let arrData: any = [];
      CheckboxOptions.forEach((item: any) => {
        arrData.push(item.value)
      })
      setselectMassPosting(arrData)
      setisSelectAll(!isSelectAll)
    } else {
      console.log('不全选')
      //关闭
      setselectMassPosting([])
      setisSelectAll(!isSelectAll)
    }
  };
  //勾选回调
  const CheckboxChange = (checkedValues: any) => {
    setselectMassPosting(checkedValues)
  };
  const [isMassPosting, setisMassPosting] = useState(false); //控制预约群发弹窗
  const MassPostingOk = () => { //确定
    if (selectMassPosting.length > 0) {
      //请求接口
      sendAppointmentTime({ externalUserIdList: selectMassPosting, sender: user || '', miniProgramPage: `/schools/bookShooting/bookShooting.html?activityId=${qywxguardian.activityId}` }).then(res => {
        console.log('群发成功', res)
        if (res.code == 0) {
          alert('群发成功')
          setisMassPosting(false)
          setselectMassPosting([])
        } else {
          alert(res.msg)
        }
      })
    } else {
      alert('请选择群发人员')
    }
  };
  const isMassPostinghandleCancel = () => { //取消
    setisMassPosting(false)
    setselectMassPosting([])
  };
  const inviteAppointmentMassSending = async () => {
    setisMassPosting(true);//拉起弹框
  }
  const [selectOrder, setselectOrder] = useState<any>({})//客户信息本地缓存
  const [selectStudentInfo, setselectStudentInfo] = useState<any>({})//选中要移动的孩子的数据
  //照片移动
  const PhotoMoveIt = async (item: any) => {
    console.log(item)
    setselectStudentInfo(item);//学生信息赋值
    if (item.photosUrl && item.photosUrl.length > 0) {
      setcreat_orderList(true);//弹框拉起
    }
  }
  const [PackageDetails, setPackageDetails] = useState<any>([])//套餐明细
  //查询订单详情
  const getOrderData = async (e: any, item: any) => {
    console.log('订单详情', item)
    e.stopPropagation(); //阻止事件冒泡
    if (item.pay_states == 1) {
      // setPackage_show(true);//弹框拉起
      // return false;
      //请求接口获取订单详情
      getPhotoOrderDetail({ tradeSn: item.trade_sn }).then(res => {
        console.log('订单详情', res)
        if (res.code == 0) {
          setPackageDetails(res.data)
          if (res.data.length > 0) {
            setPackage_show(true);//弹框拉起
          }
        }
      })
    }
  }
  //发送订单
  const sendAnOrder = async (e: any, sn: any) => {
    // 阻止事件冒泡
    e.stopPropagation();
    if (!sn) {
      alert('订单号不存在')
    } else {
      const signaturesRes = await fetchSignatures();
      if (signaturesRes) {
        wx.invoke('sendChatMessage', {
          msgtype: "miniprogram",
          miniprogram: {
            appid: "wx5bc1a7d97b54067d",//小程序的appid，企业已关联的任一个小程序
            title: "订单详情", //小程序消息的title
            imgUrl: "https://school.tangsuankeji.com/static/upload/flies/1733468169804%E3%80%90tswl%E3%80%91tsxm.jpg",//小程序消息的封面图。必须带http或者https协议头，否则报错 $apiName$:fail invalid imgUrl
            page: `/schools/packageOrder/packageOrder.html?sn=${sn}`,
          }
        }, function (res) {
        });
      }
    }
  }
  //更新订单列表
  const updateList = async () => {
    userinfo(qywxguardian.guardianId, qywxguardian.activityId).then((res: any) => { //453 11
      if (res) {
        let newRes = res
        if (newRes.orderList.length > 0) {
          newRes.orderList.map((item: any) => {
            item.open = false
          })
        }
        setuserData(newRes)
        if (res.photoInfo.length > 0) {
          let arr = res.photoInfo;
          setnotSelectedFilm(arr);
          const newArray = arr.slice(0, 5);
          setnewNotSelectedFilm(newArray);
        }
      }
    })
  }
  // 删除订单
  const DelOrder = async (e: any, sn: any, comboName: any) => {
    // 阻止事件冒泡
    e.stopPropagation();
    if (!sn) {
      alert('订单号不存在')
    } else {
      var result = window.confirm("确定删除此订单吗？");
      if (result) {
        deleteByTradeSn({ tradeSn: sn, comboName: comboName }).then(res => {
          //刷新订单列表
          updateList();
        })
      }
    }
  }
  //复制录音地址
  const handleCopyKey = async (item: string) => {
    try {
      await navigator.clipboard.writeText(item);
      alert('复制成功');
    } catch (err) {
      console.error('复制失败', err);
    }
  }
  //获取录音地址
  const getRecording = async (item: any) => {
    history(item.channelId).then(res => {
      console.log('录音地址', res)
      if (res.code == 0) {
        if (res.data.url) {
          //修改录音地址
          selectionRecordEdit({ id: item.id, recordUrl: res.data.url }).then(res => {
            if (res.code == 0) {
              // window.location.reload();
              selectionRecordList({ activityId: qywxguardian.activityId, parentId: qywxguardian.guardianId }).then((res: any) => {
                console.log('选片记录', res)
                if (res.code == 0) {
                  setselectionRecord(res.data.list)
                }
              })
            }
          })
        }
      }
    })
  }
  //关联孩子卡片
  const relatedChildren = async () => {
    if (!qywxguardian) {
      alert('未查到家长信息')
    } else {
      console.log(`/schools/relatedChildren/relatedChildren.html?activityId=${qywxguardian.activityId}|${qywxguardian.id}`)
      const signaturesRes = await fetchSignatures();
      if (signaturesRes) {
        wx.invoke('sendChatMessage', {
          msgtype: "miniprogram",
          miniprogram: {
            appid: "wx5bc1a7d97b54067d",//小程序的appid，企业已关联的任一个小程序
            title: "邀您关联孩子", //小程序消息的title
            imgUrl: "https://school.tangsuankeji.com/static/upload/flies/1733468169804%E3%80%90tswl%E3%80%91tsxm.jpg",//小程序消息的封面图。必须带http或者https协议头，否则报错 $apiName$:fail invalid imgUrl
            //关联孩子
            page: `/schools/relatedChildren/relatedChildren.html?activityId=${qywxguardian.activityId}|${qywxguardian.id}`,
          }
        }, function (res) {
        });
      }
    }
  }
  useEffect(() => {
    //获取客服信息 
    if (isqywxguardian) {
      userinfo(qywxguardian.guardianId, qywxguardian.activityId).then((res: any) => { //453 11
        if (res) {
          let newRes = res
          if (newRes.orderList.length > 0) {
            newRes.orderList.map((item: any) => {
              item.open = false
            })
          }

          let new_data: any = []; //获取绑定学生信息
          if (newRes.studentInfo.length > 0) {
            newRes.studentInfo.forEach((item: any) => {
              new_data.push({ label: item.studentName, value: item.studentId })
            })
          }
          setselectStudentList(new_data)
          setselectStudent(new_data[0].value)
          setselectStudentName(new_data[0].label)

          setuserData(newRes)
          if (res.photoInfo.length > 0) {
            let arr = res.photoInfo;
            setnotSelectedFilm(arr);
            const newArray = arr.slice(0, 5);
            setnewNotSelectedFilm(newArray);
          }
        }
      })
    }
  }, [isqywxguardian])
  //刷新选片师
  const upload_ = async () => {
    getfilmmaker(qywxguardian.activityId).then(res => {
      if (res.code == 0) {
        setourSchoolSelector(res.data.filmmaker)
      }
    })
    window.location.reload();
  }
  //手机号登录
  const [phoneNumber, setPhoneNumber] = useState('');
  //提交手机号
  const handleSubmit = (event: any) => {
    event.preventDefault();
    boundServiceUser(user, phoneNumber).then(res => {
      if (res.code == 0) {
        console.log('绑定手机号成功', res)
        localStorage.setItem("serviceInfo", JSON.stringify(res.data));
        setserviceInfo(res.data);
        setisLogin(true);
        //获取用户信息
        userInFoJson();
      } else {
        alert(res.msg)
      }
    })
  };
  //修改选片记录
  const modify = (e: any, item: any) => {
    console.log(e, item)
    if (item.id) {
      var result = window.prompt("请输入备注信息", item.selectNote ? item.selectNote : "");
      if (result != null) {
        if (result != "") {
          //修改备注
          selectionRecordEdit({ id: item.id, selectNote: result }).then(res => {
            if (res.code == 0) {
              window.location.reload();
            }
          })
        } else {
          alert('请输入备注信息')
        }
      }
    }
  };
  //退款
  const [refundSn, setrefundSn] = useState<any>(null); //退款订单sn
  const [isRefundModalOpen, setisRefundModalOpenn] = useState(false); //控制订单弹窗
  const [refundMoney, setrefundMoney] = useState<any>(''); //退款金额
  const [refundRemarks, setrefundRemarks] = useState<any>(''); //退款备注
  const isRefundModalhandleCancel = () => { //取消
    setisRefundModalOpenn(false)
    setrefundRemarks('')
    setrefundMoney('')
  };
  const isRefundModalOk = () => { //确定
    console.log(refundMoney, refundRemarks, refundSn);
    if (refundMoney && refundRemarks) {
      refund({ tradeSn: refundSn, remark: refundRemarks, payAmount: refundMoney }).then(res => {
        //刷新
        window.location.reload();
      })
    } else {
      alert('信息不能为空')
    }
  };
  const refund_ = async (e: any, sn: any) => {
    // 阻止事件冒泡
    e.stopPropagation();
    if (!sn) {
      alert('订单号不存在')
    } else {
      setrefundSn(sn)
      setisRefundModalOpenn(true)
    }
  }

  //修改订单
  const offlinePayment = async (e: any, item: any) => {
    console.log(item)
    // 阻止事件冒泡
    e.stopPropagation();
    if (!item.trade_sn) {
      alert('订单号不存在')
    } else {
      setOrderSn(item.trade_sn)
      setOrderId_(item.id)
      setisOrderModalOpen(true)
      setpaymentState(item.pay_states)
      setPaymentAmount(item.goods_price)
    }
  }
  const [OrderTypeList, setOrderTypeList] = useState([{ id: 1, name: '线上支付' }, { id: 0, name: '线下支付' }, { id: -1, name: '未支付' }]); //支付方式List
  const [OrderType, setOrderType] = useState<any>(null); //支付类型 线上 线下
  const [OrderTypeId, setOrderTypeId] = useState<any>(null); //支付类型id
  const [PaymentAmount, setPaymentAmount] = useState<any>(null); //支付金额
  const [paymentState, setpaymentState] = useState<any>(null); //订单状态
  const [OrderSn, setOrderSn] = useState<any>(null); //订单sn
  const [OrderId_, setOrderId_] = useState<any>(null); //订单Id
  const [isOrderModalOpen, setisOrderModalOpen] = useState(false); //控制订单弹窗
  const [orderRemarks, setorderRemarks] = useState<any>(''); //选片师备注
  const isOrderModalhandleCancel = () => { //取消
    setisOrderModalOpen(false)
    setOrderType(null)
    setOrderTypeId(null)
    setorderRemarks('')
  };
  const isOrderModalOk = () => { //确定
    console.log(OrderType, orderRemarks, OrderSn);
    if (OrderType) {
      if (paymentState == 0 && OrderTypeId >= 0) {
        //支付成功
        OrderSuccess({ tradeSn: OrderSn, remark: orderRemarks }).then(res => {
          console.log('支付成功', res)
        })
      }
      // 修改备注、订单方式
      editByTradeSn({ id: OrderId_, remark: orderRemarks, payMethods: OrderTypeId >= 0 ? OrderTypeId : 1, goodsPrice: PaymentAmount }).then(res => {
        console.log('修改订单添加备注', res)
        //刷新
        window.location.reload();
      })
    } else {
      alert('请选择支付类型')
    }
  };
  class SelectFilmSelector1 extends React.Component {
    handleChange = (value: any, option: any) => {
      console.log(option, value);
      setOrderType(option.value)
      setOrderTypeId(option.key)
    };
    render() {
      return (
        <Select
          placeholder="请选择支付类型"
          onChange={this.handleChange}
          showSearch
          value={OrderType}
          style={{ width: '80%' }}
        >
          {OrderTypeList.map((item: any) => (
            <Select.Option key={item.id} value={item.name}>
              {item.name}
            </Select.Option>
          ))}
        </Select>
      );
    }
  }
  //修改选片师
  const [isSelectorModalOpen, setisSelectorModalOpen] = useState(false); //控制选片师弹窗
  const [isSelectorName, setisSelectorName] = useState<any>(null); //选择的选片师名字
  const [isSelectorOrderId, setisSelectorOrderId] = useState<any>(null); //订单id
  const [isSelectorId, setisSelectorId] = useState<any>(null); //选择的选片师id
  const [FilmSelectorRemarks, setFilmSelectorRemarks] = useState<any>(''); //选片师备注
  const [FilmSelectorList, setFilmSelectorList] = useState([]); //选片师List
  const editSelector = (e: any, item: any) => { //下拉框选择
    e.stopPropagation(); //阻止事件冒泡
    if (item.pay_states == 1) {
      setisSelectorOrderId(item.id);
      setisSelectorModalOpen(true);
    }
  };
  const isSelectorModalhandleCancel = () => { //取消
    setisSelectorModalOpen(false)
  };
  const isSelectorModalOk = () => { //确定
    console.log(isSelectorId, isSelectorName, FilmSelectorRemarks)
    if (isSelectorId && isSelectorName) {
      //请求接口
      orderEdit({ id: isSelectorOrderId, remark: FilmSelectorRemarks, createBy: isSelectorId, createByName: isSelectorName }).then(res => {
        if (res.code == 0) {
          setisSelectorModalOpen(false)
          setisSelectorName(null)
          setisSelectorId(null)
          window.location.reload();
        }
      })

    } else {
      alert('请选择选片师')
    }
  };
  //选择选片师
  class SelectFilmSelector extends React.Component {
    handleChange = (value: any, option: any) => {
      console.log(value, option)
      setisSelectorName(option.value)
      setisSelectorId(option.key)
    };
    render() {
      return (
        <Select
          placeholder="请选择选片师"
          onChange={this.handleChange}
          showSearch
          value={isSelectorName}
          style={{ width: '80%' }}
        >
          {FilmSelectorList.map((item: any) => (
            <Select.Option key={item.id} value={item.name}>
              {item.name}
            </Select.Option>
          ))}
        </Select>
      );
    }
  }
  // 获取当前外部联系人信息(客服)
  const getUserInfo = async () => {
    setLoading(true);
    const userId = Cookies.get('userId')
    const serviceInfo = localStorage.getItem('serviceInfo');
    console.log('userId', userId,)
    console.log('serviceInfo', serviceInfo)
    if (serviceInfo) {
      setserviceInfo(JSON.parse(serviceInfo));
      setLoading(false)
      if (userId) {
        setUser(userId)
        //请求接口判断是否绑定手机号
        isboundServiceUser(userId).then((res: any) => {
          // alert('是否绑定手机：' + JSON.stringify(res))
          if (res.data.code == 0) { // || res.data.code == 20010
            //已绑定手机号
            setisLogin(true)
            //获取客户信息
            userInFoJson();
          } else {
            //未绑定手机号
            setisLogin(false)
          }
        })
      }
    } else {
      setLoading(false)
      //未绑定手机号
      setisLogin(false)
    }

  }
  // useEffect(() => {
  //   console.log('formData updated:', formData);
  // }, [formData]);
  // 获取当前用户信息
  const userInFoJson = async () => {
    // 获取用户前先获取 ticket
    const ticket = await getSignaturesTicket();
    let agentConfigRes: any = null;
    if (ticket) {
      agentConfigRes = await jsSdk.agentConfig({
        corpid: 'wwe2d0f3a112afa689',
        agentid: '1000003',
        timestamp: ticket.meta.timestamp,
        nonceStr: ticket.meta.nonceStr,
        signature: ticket.app.signature,
        jsApiList: apis
      })
        .catch(e => {
          console.error(e)
        });
      if (agentConfigRes) {
        wx.invoke("getCurExternalContact", {}, function (res) {
          if (res.err_msg == "getCurExternalContact:ok") {
            let externalUserId = res.userId; //返回当前外部联系人userId 线上
            setexternalUserId_(res.userId);
            // let externalUserId = 'wmxCI8MQAAvcOxZVZ82Pi-lYL3MWjRJA'; //本地测试
            if (externalUserId) {
              //获取外部用户userid
              fetchExternalUser(externalUserId).then((res: any) => {
                setuserInFo(res);
                //1.请求活动列表
                getdatalist({ states: 1 }).then(res => {
                  if (res.code == 0) {
                    setOPTIONSList_(res.data)
                    let arr_: any[] = [];
                    res.data.forEach(((item: any) => {
                      arr_.push(item.name)
                    }))
                    setOPTIONS(arr_)
                  }
                })
                getqywxguardian(externalUserId).then((res: any) => {
                  if (res.code == 0) {
                    //已绑定
                    if (res.data.guardianId) {
                      setqywxguardian(res.data)
                      setisqywxguardian(true)
                      //2.在useEffect监听setqywxguardian去请求页面数据
                      //3.请求选片师
                      getfilmmaker(res.data.activityId).then(res => {
                        if (res.code == 0) {
                          setourSchoolSelector(res.data.filmmaker)
                        }
                      })
                      //4.请求套餐列表
                      getPackage({ activityId: res.data.activityId }).then(res => {
                        if (res.code == 0 && res.data) {
                          let new_datas = res.data
                          if (new_datas.photoComboDOS && new_datas.photoComboDOS.length > 0) {
                            //套餐
                            new_datas.photoComboDOS.forEach((item: any) => {
                              item.label = `${item.name}|￥${item.price}|入册：${item.enrollmentNum ? item.enrollmentNum : 0}张-赠送：${item.gift ? item.gift : '无'}`
                              item.value = item.id
                            })
                            setPackage_(new_datas.photoComboDOS)
                          }
                          if (new_datas.photoAlbum && new_datas.photoAlbum.length > 0) {
                            //实物单品
                            new_datas.photoAlbum.forEach((item: any) => {
                              item.label = `${item.productName}|￥${item.productPrice}|入册：${item.enrollmentNum ? item.enrollmentNum : 0}张-赠送：${item.gift ? item.gift : '无'}`
                              item.value = item.id
                            })
                            setphysicalItem(new_datas.photoAlbum)
                          }
                          if (new_datas.photoNegative && new_datas.photoNegative.length > 0) {
                            //底片单品
                            new_datas.photoNegative.forEach((item: any) => {
                              item.label = `${item.productName}|￥${item.productPrice}|入册：${item.enrollmentNum ? item.enrollmentNum : 0}张-赠送：${item.gift ? item.gift : '无'}`
                              item.value = item.id
                            })
                            setfilmSingleItem(new_datas.photoNegative)
                          }
                        }
                      })
                      //5.查询选片记录
                      selectionRecordList({ activityId: res.data.activityId, parentId: res.data.guardianId }).then((res: any) => {
                        console.log('选片记录', res)
                        if (res.code == 0) {
                          setselectionRecord(res.data.list)
                        }
                      })
                      //6.查询所有选片师
                      getAllSelector().then((res: any) => {
                        console.log('所有选片师', res)
                        if (res.code == 0) {
                          setFilmSelectorList(res.data)
                        }
                      })
                      //7.查询活动下的群发人员
                      getGuardiansByActivityId({ activityId: res.data.activityId }).then(res => {
                        if (res.code == 0) {
                          let new_options = JSON.stringify(res.data)
                          new_options = new_options.replace(/nickName/g, "label").replace(/externalUserId/g, "value")
                          console.log(JSON.parse(new_options))
                          setCheckboxOptions(JSON.parse(new_options))
                          setkeepCheckboxOptions(JSON.parse(new_options))
                        }
                      })
                    } else {
                      setqywxguardian(res.data)
                      setMsg('未绑定学生信息')
                      //未绑定学生
                      setisqywxguardian(false)
                    }
                  } else {
                    setMsg(res.msg)
                    //未绑定学生
                    setisqywxguardian(false)
                  }
                })
              })
            }
          } else {
            alert("获取外部联系人失败");
          }
        });
      }
    }
  }
  //选择活动
  const [OPTIONS, setOPTIONS] = useState<any[]>([]);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  class SelectWithHiddenSelectedOptions extends React.Component {
    handleChange = (selectedItems: any) => {
      // setformData({ ...formData, grade: '' })
      setoptions('')
      let numR = OPTIONSList_.filter((items: any) => {
        return items.name == selectedItems;
      })
      console.log(numR, numR[0].id, numR[0].cid)
      if (numR.length > 0) {
        setformData((formData: any) => ({ ...formData, activityId: numR[0].id }));
        setSelectedItems(selectedItems)
        getStudentByClassId({ currentPage: -1, pageSize: -1, filterData: { cid: numR[0].cid } }).then(res => {
          if (res.code == 0) {
            setstudentList_(res.data.tabledata)
          }
        })
        //获取班级列表
        // getschooloptionsbyactivityid({ activityId: numR[0].id }).then(res => { //res.data.activityId  23
        //   if (res.code == 0 && res.data) {
        //     let new_options = JSON.stringify(res.data)
        //     new_options = new_options.replace(/id/g, "value")
        //     new_options = new_options.replace(/name/g, "label")
        //     new_options = new_options.replace(/classes/g, "children")
        //     let options = JSON.parse(new_options)
        //     setoptions(options)
        //     setformData((formData: any) => ({ ...formData, activityId: numR[0].id, schoolLocation: options[0].label }));
        //     //学校存储
        //     setschool(options[0].label)
        //     setSelectedItems(selectedItems)
        //     console.log(formData)
        //   }
        // })
      }
    };

    render() {
      const filteredOptions = OPTIONS.filter(o => !selectedItems.includes(o));
      return (
        <Select
          placeholder="请选择活动"
          value={selectedItems}
          onChange={this.handleChange}
          showSearch
          style={{ width: '80%' }}
        >
          {filteredOptions.map(item => (
            <Select.Option key={item} value={item}>
              {item}
            </Select.Option>
          ))}
        </Select>
      );
    }
  }
  const [stduentInfo, setstduentInfo] = useState<any>([]);//绑定学生，选择的学生信息
  //选择学生
  class SelectWithHiddenSelectedStudent extends React.Component {
    handleChange = (value: any, option: any) => {
      setformData((formData: any) => ({ ...formData, name: option.value, studentId: option.key }));
      setstduentInfo(studentList_.filter((item: any) => item.id == option.key));
    };
    render() {
      return (
        <Select
          placeholder="请选择学生"
          onChange={this.handleChange}
          showSearch
          value={formData.name}
          style={{ width: '80%' }}
        >
          {studentList_.map((item: any) => (
            <Select.Option key={item.id} value={item.name}>
              {item.name}
            </Select.Option>
          ))}
        </Select>
      );
    }
  }

  useEffect(() => {
    //获取客服信息
    getUserInfo().then()
  }, [])
  return (
    <Spin spinning={loading}>
      <div style={{ width: '100%', height: '95vh', background: '#fff', display: !isLogin ? 'flex' : 'none', justifyContent: 'center', alignContent: 'center' }}>
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <h2 style={{ marginBottom: '60px', fontWeight: 'bold', fontSize: '20px' }}>手机号登录</h2>
          <form onSubmit={handleSubmit}>
            <div>
              <label htmlFor="phoneNumber" >
                手机号码
              </label>
              <input
                type="tel"
                id="phoneNumber"
                placeholder="请输入手机号码"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
              />
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <button type="submit" style={{ marginTop: '10px', width: '150px', height: '30px', lineHeight: '30px', border: 'none', borderRadius: '5px', background: '#1890ff', color: '#fff' }}>
                登录
              </button>
            </div>
          </form>
        </div>
      </div>
      <div style={{ display: isLogin ? 'block' : 'none' }}>
        {/* <h1>欢迎回来，{user ? user.name : ''}</h1>
        <div>{JSON.stringify(user)}</div>
        <Action /> */}
        {/* 手动加载微应用 */}
        {/* <MicroAppComponent user={user} /> */}
        <div style={container}>
          <div>外部id：{externalUserId_}</div>
          {/* {selectStudentName}-{selectStudent}
          <Radio.Group onChange={selectStudentonChange} value={selectStudent} options={selectStudentList}></Radio.Group> */}
          <div style={filmSelector0}>
            <div style={filmSelectorIndex === 0 ? filmSelectorbtn_right_bottom : filmSelectorbtn_right} onClick={() => filmSelectorBtnClick(0)}>本校选片师</div>
            <button style={{ cursor: 'pointer' }} onClick={() => upload_()}>刷新</button>
            {/* <div style={filmSelectorIndex === 1 ? filmSelectorbtn_right_bottom : filmSelectorbtn_right} onClick={() => filmSelectorBtnClick(1)}>全部选片师</div> */}
          </div>
          <div style={filmSelector1}>
            {/* 本校选片师 */}
            <div style={{ display: filmSelectorIndex === 0 ? 'block' : 'none', maxHeight: '150px', overflowY: 'scroll', width: '100%' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
                {
                  ourSchoolSelector && ourSchoolSelector.length > 0 ?
                    ourSchoolSelector.map((item: any, index: number) => (
                      <div key={index} style={{ display: 'flex', width: '100%', height: '25px', lineHeight: '25px', justifyContent: 'space-between', 'overflow': 'hidden' }}>
                        <div style={{ textAlign: 'left', height: '25px', lineHeight: '25px', display: 'flex' }}>
                          {item.name}
                          <span style={{ display: item.parentName ? 'block' : 'none' }}> | </span>
                          <span style={{ display: item.parentName ? 'block' : 'none', color: 'red' }}>{item.parentName}</span>
                        </div>
                        <div style={{ textAlign: 'right', height: '25px', lineHeight: '25px', color: item.state == '0' ? '#08cd08' : 'red' }}>{item.state == '0' ? '在线' : item.state == '1' ? '占线' : item.state == '-1' ? '离线' : '通话中'}</div>
                      </div>
                    ))
                    : '暂无选片师'
                }
              </div>
            </div>
            {/* 全部选片师 */}
            {/* <div style={{ display: filmSelectorIndex === 1 ? 'block' : 'none', maxHeight: '150px', overflowY: 'scroll', width: '100%' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
                {
                  allSelector.map((item: any, index: number) => (
                    <div key={item.index} style={{ display: 'flex', width: '100%', height: '25px', lineHeight: '25px', justifyContent: 'space-between', 'overflow': 'hidden' }}>
                      <div style={{ textAlign: 'left', height: '25px', lineHeight: '25px' }}>{item.name}</div>
                      <div style={{ textAlign: 'right', height: '25px', lineHeight: '25px', color: item.state == '对话中' || item.state == '忙碌' ? 'red' : '#08cd08' }}>{item.state}</div>
                    </div>
                  ))
                }
              </div>
            </div> */}
          </div>
          <div style={section}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
              <div style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>用户信息</div>
              <div style={{ display: 'flex' }}>
                <span style={{ cursor: 'pointer' }} onClick={() => relatedChildren()}>邀请关联孩子</span>
                <span style={{ margin: '0 5px' }}>|</span>
                <span onClick={showDrawer} style={{ cursor: 'pointer' }}>关联孩子</span>
              </div>
            </div>
            <Drawer
              width='90%'
              title="关联孩子"
              placement="right"
              closable={true}
              onClose={onClose}
              visible={drawer_}
              maskClosable={false}
              destroyOnClose={true}
            >

              {/* 绑定孩子按钮 */}
              <div onClick={() => setbing(!bing)} style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginBottom: '5px' }}><div style={{ border: '1px solid #ccc', padding: '0px 10px', cursor: 'pointer', borderRadius: '5px' }}>添加孩子</div></div>
              {/* 已绑定孩子 解绑 */}
              <Table dataSource={dataSource} columns={columns} pagination={false} />
              {/* 填写信息 */}
              <div style={{ display: bing ? 'block' : 'none', marginTop: '10px' }}>
                <div style={{ height: '32px', display: 'flex', lineHeight: '32px', marginBottom: '5px' }}><div style={{ width: '30%' }}>本次活动：</div><SelectWithHiddenSelectedOptions /></div>
                <div style={{ height: '32px', display: 'flex', lineHeight: '32px', marginBottom: '5px' }}><div style={{ width: '30%' }}>学生姓名：</div><SelectWithHiddenSelectedStudent /></div>
                <div style={{ height: '32px', display: 'flex', lineHeight: '32px', marginBottom: '5px' }}>
                  <div style={{ width: '30%' }}>身份：</div>
                  <div style={{ width: '70%', boxSizing: 'border-box', cursor: 'pointer' }}>
                    <AutoComplete
                      options={identityList}
                      style={{ width: 100 + '%' }}
                      onSelect={data => setformData({ ...formData, chooseIdentity: data })}
                      onSearch={data => setformData({ ...formData, chooseIdentity: data })}
                      placeholder="请输入身份"
                    />
                  </div>
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}><div style={{ width: '20%' }}></div><button onClick={() => handle()} style={{ width: '200px' }}>提交</button></div>
              </div>
            </Drawer>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ width: '75%' }}>
                <div style={{ display: isqywxguardian ? 'block' : 'none' }}>昵称：{userInFo.name}</div>
                <div style={{ display: isqywxguardian ? 'block' : 'none' }}>身份：{userData && userData.guardianInfo.length > 0 ? intercept(userData.guardianInfo[userData.guardianInfo.length - 1].nick_name) : '未知'}</div>
                <div style={{ display: isqywxguardian ? 'block' : 'none' }}>电话：{userData && userData.guardianInfo.length > 0 ? userData.guardianInfo[userData.guardianInfo.length - 1].phone : '未知'}</div>
                <div style={{ display: !isqywxguardian ? 'block' : 'none' }}>{Msg}</div>
              </div>
              <div style={{ width: '25%', display: 'flex', justifyContent: 'flex-end' }}>
                {/* 生成二维码 */}
                {/* <QRCode value={qrValue} size={100} /> */}
              </div>
            </div>
          </div>
          <div style={{ display: isqywxguardian ? 'block' : 'none', marginBottom: '10px', background: '#fafafb', borderRadius: '5px', padding: '5px' }}>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                {
                  userData && userData.studentInfo.length > 0 ?
                    (userData.studentInfo.map((item: any, index: number) => (
                      <div key={index} style={{ width: '100%', marginBottom: '5px' }}>
                        <div style={{ cursor: 'pointer' }} onClick={() => PhotoMoveIt(item)}>
                          <div style={{ width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', wordBreak: 'break-all' }}>学生姓名：<span style={{ color: '#000' }}>{item.studentName ? item.studentName : ''}</span><span style={{ color: item.photosUrl ? '#000' : '#000' }}>{item.photosUrl ? `(${item.photosUrl.length}张)` : ''}</span></div>
                          <div style={{ width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', wordBreak: 'break-all' }}>学校活动：{item.studentName ? item.schoolActivity : ''}</div>
                          <div style={{ width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', wordBreak: 'break-all' }}>所属团队：{item.studentName ? item.teamName : ''}</div>
                          <div style={{ width: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ display: item.type1 ? 'block' : 'none' }}>主场景摄影：{item.type1 ? item.type1 : ''}</div>
                            <div style={{ display: item.type2 ? 'block' : 'none' }}>副场景摄影：：{item.type2 ? item.type2 : ''}</div>
                          </div>
                          <div style={{ width: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ display: item.type3 ? 'block' : 'none' }}>第三场景摄影：：{item.type3 ? item.type3 : ''}</div>
                            <div style={{ display: item.type4 ? 'block' : 'none' }}>第四场景摄影：：{item.type4 ? item.type4 : ''}</div>
                          </div>
                        </div>
                        <div style={{ width: '100%', alignItems: 'center', overflowY: 'scroll', maxHeight: '180px', flexWrap: 'wrap', justifyContent: 'center', flexDirection: 'column', display: item.photosUrl ? 'block' : 'none' }}>
                          <div style={{ width: '100%', display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                            {
                              item.photosUrl ?
                                (item.photosUrl.map((photo: any, index1: number) => ( //全部照片
                                  <div key={photo} style={{ width: '17%', height: '170px', overflow: 'hidden', display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '10px', justifyContent: 'center', position: 'relative' }}>
                                    <div style={{ width: '100%', height: '150px', display: 'flex', justifyContent: 'center', alignContent: 'center', background: '#fff' }}>
                                      <img src={photo} loading="lazy" style={{ width: '100%', height: 'auto', objectFit: 'contain' }} onClick={() => handlePhotoClick(photo, index, index1 + 1)} />
                                    </div>
                                  </div>
                                )))
                                :
                                (<div style={{ width: '100%', textAlign: 'center' }}></div>)
                            }
                          </div>
                        </div>
                      </div>
                    )))
                    :
                    (<div style={{ width: '100%', textAlign: 'center' }}></div>)
                }
                <div style={{ width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', wordBreak: 'break-all' }}>预约时间：{userData && userData.appointmentTime ? formatDate(userData.appointmentTime) : '未预约'}</div>
              </div>
            </div>
            <div style={btn_bottom}>
              <button style={{ cursor: 'pointer', marginRight: '5px', display: notSelectedFilm.length > 0 ? 'block' : 'none' }} onClick={() => sendMissage()}>选片卡片</button>
              <button style={{ cursor: 'pointer', marginRight: '5px', display: qywxguardian ? 'block' : 'none' }} onClick={() => inviteAppointment()}>邀请预约</button>
              <button style={{ cursor: 'pointer', marginRight: '5px', display: qywxguardian ? 'block' : 'none' }} onClick={() => inviteAppointmentMassSending()}>邀请预约(群发)</button>
            </div>
            {/* <div style={btn_bottom}>
              <button style={{ cursor: 'pointer', marginRight: '5px', border: '1px solid red' }}>提醒</button>
              <button style={{ cursor: 'pointer', marginRight: '5px', border: '1px solid red' }}>事件</button>
            </div> */}
            <Drawer
              width='90%'
              title="创建订单"
              placement="right"
              closable={true}
              onClose={onCheckClose}
              visible={creat_order}
              maskClosable={false}
              destroyOnClose={true}
            >
              <h3 style={{ display: Package_.length > 0 ? 'block' : 'none' }}>套餐：</h3>
              <Checkbox.Group options={Package_} onChange={Package_Click} style={{ display: Package_.length > 0 ? 'block' : 'none' }} />
              <br style={{ display: Package_.length > 0 ? 'block' : 'none' }} />

              <h3 style={{ display: physicalItem.length > 0 || filmSingleItem.length > 0 ? 'block' : 'none' }}>单品</h3>

              <h4 style={{ marginBottom: '0', display: physicalItem.length > 0 ? 'block' : 'none' }}>{`实物单品`}</h4>
              <Checkbox.Group options={physicalItem} onChange={physicalItemClick} style={{ display: physicalItem.length > 0 ? 'block' : 'none' }} />
              <br style={{ display: physicalItem.length > 0 ? 'block' : 'none' }} />

              <h4 style={{ marginBottom: '0', display: filmSingleItem.length > 0 ? 'block' : 'none' }} >{`底片单品`}</h4>
              <Checkbox.Group options={filmSingleItem} onChange={filmSingleItemClick} style={{ display: filmSingleItem.length > 0 ? 'block' : 'none' }} />
              <br style={{ display: filmSingleItem.length > 0 ? 'block' : 'none' }} />

              <h4 style={{ marginBottom: '0', display: selectStudentList.length > 0 ? 'block' : 'none' }} >{`学生姓名`}</h4>
              <Radio.Group onChange={selectStudentonChange} value={selectStudent} options={selectStudentList} style={{ display: filmSingleItem.length > 0 ? 'block' : 'none' }}></Radio.Group>
              <br style={{ display: filmSingleItem.length > 0 ? 'block' : 'none' }} />

              <h4 style={{ marginBottom: '0', display: filmSingleItem.length > 0 ? 'block' : 'none' }} >{`入册张数`}</h4>
              <input placeholder="请输入入册张数" value={max_photo} onChange={(e) => setmax_photo(e.target.value)} />
              <br />

              <br />
              <div style={{ display: 'flex', justifyContent: 'center' }}><Button loading={orderLoading} style={{ cursor: 'pointer', width: '200px', background: '#0686f7', border: 'none', color: '#fff' }} onClick={() => saveOrderList()}>创建订单</Button></div>
            </Drawer>
          </div>
          {/* 照片移动 */}
          <Drawer
            width='90%'
            title=""
            placement="right"
            closable={true}
            onClose={onCheckCloseList}
            visible={creat_orderList}
            maskClosable={false}
            destroyOnClose={true}
          >
            <div style={{ marginBottom: '10px', background: '#fafafb', borderRadius: '5px', position: 'relative', height: '90%' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '90%' }}>
                <div style={{ display: selectStudentInfo && selectStudentInfo.photosUrl ? 'block' : 'none' }}>照片({selectStudentInfo.photosUrl ? selectStudentInfo.photosUrl.length : 0})</div>
                <div style={{ cursor: 'pointer' }} onClick={() => selectAll()}>全选/反选</div>
              </div>
              <div style={{ width: '100%', alignItems: 'center', overflowY: 'scroll', maxHeight: '500px', flexWrap: 'wrap', justifyContent: 'center' }}>
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', flexWrap: 'wrap', }}>
                  {
                    selectStudentInfo && selectStudentInfo.photosUrl ?
                      (selectStudentInfo.photosUrl.map((photo: any, index: number) => ( //需要选择的照片
                        <div key={index} style={{ width: '30%', height: '180px', overflow: 'hidden', display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '10px', justifyContent: 'center', position: 'relative' }}>
                          <div style={{ width: '100%', height: '150px', display: 'flex', justifyContent: 'center', alignContent: 'center', background: '#fff' }}>
                            <img loading="lazy" src={photo} style={{ width: '100%', height: 'auto', objectFit: 'contain' }} onClick={() => handlePhotoClick2(photo, index)} />
                          </div>
                          <input
                            type="checkbox"
                            checked={selectedPhotos.includes(photo)}
                            onChange={(e) => handleCheckboxChange(e, photo)}
                            style={{ width: '20px', height: '20px', position: 'absolute', top: '15px', right: '0px', zIndex: 2 }}
                          ></input>
                        </div>
                      )))
                      :
                      (<div style={{ width: '100%', textAlign: 'center', marginTop: '50px' }}>暂无照片</div>)
                  }
                </div>
              </div>
              <div style={{ height: '32px', display: 'flex', marginBottom: '5px', marginTop: '10px' }}>活动：<SelectWithHiddenSelectedOptions /></div>
              {/* <div style={{ height: '32px', display: 'flex', marginBottom: '5px' }}>班级：<Cascader options={options} onChange={onChange} placeholder="请选择班级" style={{ width: '80%' }} /></div> */}
              <div style={{ height: '32px', display: 'flex', marginBottom: '5px' }}>学生：<SelectWithHiddenSelectedStudent /></div>
              <div style={{ display: selectedPhotos.length > 0 ? 'block' : 'none', marginTop: '20px' }}>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}><Button loading={orderListLoading} onClick={() => photoHandle()} style={{ width: '200px' }}>提交({selectedPhotos.length})</Button></div>
              </div>
              {
                currentPhoto2 && (
                  <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999, flexDirection: 'column' }} onClick={() => setCurrentPhoto2(null)}>
                    <img src={currentPhoto2} style={{ maxWidth: '90%', maxHeight: '90%' }} />
                    <div style={{ width: '100%', textAlign: 'center', display: urlIndex2 !== -1 ? 'block' : 'none', color: '#fff' }}>{urlIndex2 + 1}/{selectStudentInfo.photosUrl.length}</div>
                  </div>
                )
              }
            </div>
          </Drawer>
          {/* 套餐详情 */}
          <Drawer
            width='90%'
            title="套餐详情"
            placement="right"
            closable={true}
            onClose={onshowCloseList}
            visible={Package_show}
            maskClosable={false}
            destroyOnClose={true}
          >
            <div style={{ position: 'relative', display: PackageDetails.length > 0 ? 'block' : 'none' }}>
              <div style={{ backgroundColor: '#FFFFFF', padding: '10px', borderRadius: '7px', width: '95%', margin: '10px auto', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#333333' }}>{PackageDetails && PackageDetails.length > 0 ? PackageDetails[0].studentName : ''}</span>
                <div>{PackageDetails && PackageDetails.length > 0 ? PackageDetails[0].tradeSn : ''}</div>
              </div>
              {
                PackageDetails && PackageDetails.length > 0 ?
                  (PackageDetails.map((item: any, index: any) => (
                    <div key={item.id} style={{ borderBottom: '1px dashed #eee', padding: '10px' }}>
                      <div style={{ display: 'flex' }}>
                        <img loading="lazy" onClick={() => handlePhotoClick1(item.productUrl, -1)} src={item.productUrl} style={{ width: '80px', height: '80px', objectFit: 'contain', borderRadius: '2px', marginRight: '8px' }} />
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: '1' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ width: '82%', fontSize: '16px', color: '#333' }}>{item.goodsName}</div>
                            <div style={{ fontSize: '16px', color: '#333' }}>¥{item.goodsPrice}</div>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginRight: '8px' }}>
                              <div style={{ color: '#909399' }}>入册:</div>
                              <div>{item.maxPhoto}-{item.minPhoto}</div>
                            </div>
                            <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginRight: '8px' }}>
                              <div style={{ color: '#909399' }}>赠送:</div>
                              <div>{item.category == 1 ? '入册底片' : '全部底片'}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* 查询入册照片 */}
                      <div style={{ display: item.minPhoto > 0 ? 'block' : 'none' }}>照片({item.activitiesPhotoIds && item.activitiesPhotoIds.length})</div>
                      <div style={{ display: item.activitiesPhotoIds && item.minPhoto > 0 ? 'block' : 'none' }}>
                        <div style={{ display: 'flex', alignContent: 'center', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                          {
                            item.activitiesPhotoIds && item.activitiesPhotoIds.length > 0 ?
                              (item.activitiesPhotoIds.map((photo: any) => (
                                <img loading="lazy" onClick={() => handlePhotoClick1(photo, index)} src={photo} style={{ width: '80px', height: '80px', objectFit: 'contain', marginBottom: '10px' }} />
                              )))
                              :
                              (<div style={{ width: '100%', textAlign: 'center', marginTop: '50px' }}></div>)
                          }
                        </div>
                      </div>
                      {/* 查询底片 */}
                      <div style={{ display: item.minPhoto == 0 ? 'block' : 'none' }}>照片({item.negativeList && item.negativeList.length})</div>
                      <div style={{ display: item.negativeList && item.minPhoto == 0 ? 'block' : 'none' }}>
                        <div style={{ display: 'flex', alignContent: 'center', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                          {
                            item.negativeList && item.negativeList.length > 0 ?
                              (item.negativeList.map((photo: any) => (
                                <img loading="lazy" onClick={() => handlePhotoClick1(photo, index)} src={photo} style={{ width: '80px', height: '80px', objectFit: 'contain', marginBottom: '10px' }} />
                              )))
                              :
                              (<div style={{ width: '100%', textAlign: 'center', marginTop: '50px' }}></div>)
                          }
                        </div>
                      </div>
                    </div>
                  )))
                  :
                  (<div style={{ width: '100%', textAlign: 'center', marginTop: '50px' }}></div>)
              }
            </div>
            {
              currentPhoto1 && (
                <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999, flexDirection: 'column' }} onClick={() => setCurrentPhoto1(null)}>
                  <img src={currentPhoto1} style={{ maxWidth: '90%', maxHeight: '90%' }} />
                </div>
              )
            }
          </Drawer>
          {/* 修改订单选片师 */}
          <Modal
            title="修改订单选片师"
            visible={isSelectorModalOpen}
            onOk={isSelectorModalOk}
            onCancel={isSelectorModalhandleCancel}
            destroyOnClose
          >
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
              <div style={{ width: '80%', display: 'flex', marginBottom: '5px', justifyContent: 'space-between' }}>
                <div>请选择选片师：</div>
                <div style={{ width: '200px', display: 'flex', justifyContent: 'space-between' }}><SelectFilmSelector /></div>
              </div>
              <div style={{ width: '80%', display: 'flex', justifyContent: 'space-between' }}>
                <div>请输入备注信息：</div>
                <div style={{ width: '200px', display: 'flex', justifyContent: 'space-between' }}>
                  <input
                    placeholder="请输入备注信息"
                    value={FilmSelectorRemarks}
                    onChange={(e) => setFilmSelectorRemarks(e.target.value)}
                  /></div>
              </div>
            </div>
          </Modal>
          {/* 预约群发 */}
          <Modal
            title="预约群发"
            visible={isMassPosting}
            onOk={MassPostingOk}
            onCancel={isMassPostinghandleCancel}
            destroyOnClose
          >
            <div>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center', marginBottom: '10px' }}>
                <SelectFilmSelector88 /><SelectFilmSelector99 />
                <span style={{ height: '32px', lineHeight: '32px', cursor: 'pointer', marginLeft: '20px' }} onClick={() => Init()}>重置</span>
              </div>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span>总数：{CheckboxOptions ? CheckboxOptions.length : 0}</span>
                <span style={{ cursor: 'pointer' }} onClick={() => SelectAll()}>全选/反选</span>
              </div>
              <div style={{ maxHeight: '300px', overflowY: 'scroll', marginBottom: '10px' }}>
                <Checkbox.Group options={CheckboxOptions} name={CheckboxOptions.label} value={selectMassPosting} onChange={CheckboxChange} />
              </div>
              <span>已选：{selectMassPosting ? selectMassPosting.length : 0}</span>
            </div>
          </Modal>
          {/* 修改订单状态 */}
          <Modal
            title="修改订单状态"
            visible={isOrderModalOpen}
            onOk={isOrderModalOk}
            onCancel={isOrderModalhandleCancel}
            destroyOnClose
          >
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
              <div style={{ width: '80%', display: 'flex', marginBottom: '5px', justifyContent: 'space-between' }}>
                <div>请选择支付类型：</div>
                <div style={{ width: '200px', display: 'flex', justifyContent: 'space-between' }}><SelectFilmSelector1 /></div>
              </div>
              <div style={{ width: '80%', display: 'flex', marginBottom: '5px', justifyContent: 'space-between' }}>
                <div>请输入订单金额：</div>
                <div style={{ width: '200px', display: 'flex', justifyContent: 'space-between' }}>
                  <input
                    placeholder="请输入订单金额"
                    value={PaymentAmount}
                    onChange={(e) => setPaymentAmount(e.target.value)}
                    type="number"
                  /></div>
              </div>
              <div style={{ width: '80%', display: 'flex', justifyContent: 'space-between' }}>
                <div>请输入备注信息：</div>
                <div style={{ width: '200px', display: 'flex', justifyContent: 'space-between' }}>
                  <input
                    placeholder="请输入备注信息"
                    value={orderRemarks}
                    onChange={(e) => setorderRemarks(e.target.value)}
                  /></div>
              </div>
            </div>
          </Modal>
          {/* 退款 */}
          <Modal
            title="退款"
            visible={isRefundModalOpen}
            onOk={isRefundModalOk}
            onCancel={isRefundModalhandleCancel}
            destroyOnClose
          >
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
              <div style={{ width: '80%', display: 'flex', justifyContent: 'space-between' }}>
                <div>请输入退款金额：</div>
                <div style={{ width: '200px', display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                  <input
                    placeholder="请输入退款金额"
                    value={refundMoney}
                    onChange={(e) => setrefundMoney(e.target.value)}
                    type="number"
                  /></div>
              </div>
              <div style={{ width: '80%', display: 'flex', justifyContent: 'space-between' }}>
                <div>请输入备注信息：</div>
                <div style={{ width: '200px', display: 'flex', justifyContent: 'space-between' }}>
                  <input
                    placeholder="请输入备注信息"
                    value={refundRemarks}
                    onChange={(e) => setrefundRemarks(e.target.value)}
                  /></div>
              </div>
            </div>
          </Modal>
          {/* 放大显示的图片 */}
          {
            currentPhoto && (
              <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999, flexDirection: 'column' }} onClick={() => setCurrentPhoto(null)}>
                <img src={currentPhoto} style={{ maxWidth: '90%', maxHeight: '90%' }} />
                <div style={{ width: '100%', textAlign: 'center', color: '#fff' }}>{urlIndex}/{AllurlIndex}</div>
              </div>
            )
          }
          <div style={{ display: isqywxguardian ? 'block' : 'none', marginBottom: '10px', background: '#fafafb', borderRadius: '5px', padding: '5px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
              <div style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>订单列表</div>
              <button style={{ cursor: 'pointer', marginRight: '5px' }} onClick={() => isOrderList()}>创建订单</button>
            </div>
            <div style={{ maxHeight: '400px', overflowY: 'scroll', width: '100%', display: 'flex', flexDirection: 'column' }}>
              {
                userData && userData.orderList.length > 0 ?
                  userData.orderList.map((item: any, index: any) => (
                    <div key={index} style={{ marginBottom: '10px', background: '#fff', width: '100%', padding: '2px 0', cursor: 'pointer' }} onClick={(e) => getOrderData(e, item)}>
                      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ width: '50%', overflow: 'hidden' }}>下单时间：{formatDate(item.create_time)}</div>
                        <div style={{ width: '50%', overflow: 'hidden', textAlign: 'right' }}>支付时间：{item.payment_time ? formatDate(item.payment_time) : '未知'}</div>
                      </div>
                      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ width: '50%', overflow: 'hidden' }}>订单号：{item.trade_sn}</div>
                        <div style={{ width: '50%', overflow: 'hidden', textAlign: 'right' }}>
                          {/* {item.pay_states == 1 ? `已支付${item.isDownload ? "(已下载)" : '(未下载)'}` : item.pay_states === 0 ? '未支付' : item.pay_states === 2 ? '已退款' : '未知'} */}
                          <span style={{ color: item.pay_states == 1 ? 'red' : '#000', display: item.pay_states == 1 ? 'inline-block' : 'none' }}>{item.pay_methods == 0 ? `线下支付|` : item.pay_methods === 1 ? '线上支付|' : ''}</span>
                          <span style={{ color: item.pay_states == 1 || item.pay_states == 2 ? 'red' : '#000' }}>{item.pay_states == 1 ? `已支付` : item.pay_states === 0 ? '未支付' : item.pay_states === 2 ? '已退款' : '未知'}</span>
                          <span style={{ color: item.isDownload ? 'red' : '#000' }}>{item.isDownload > 0 ? "(已下载)" : '(未下载)'}</span>
                          {item.order_states && item.pay_states === 1 ? ` | ${item.order_states}` : ''}</div>
                      </div>
                      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ width: '50%', overflow: 'hidden' }}>商品名称：{item.goods_name}</div>
                        <div style={{ width: '50%', overflow: 'hidden', textAlign: 'right' }}>实付金额：{item.goods_price}元</div>
                      </div>
                      <div style={{ width: '100%', marginBottom: '2px', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
                        <div style={{ width: '50%', overflow: 'hidden' }}>学生姓名：{item.student_name ? item.student_name : '未知'}</div>
                        <div style={{ width: '50%', display: item.pay_states === 1 && item.createByName ? 'block' : 'none', textAlign: 'right' }}>选片师：<span onClick={(e) => { editSelector(e, item) }} style={{ textDecoration: 'underline', color: 'rgb(72, 171, 66)' }}>{item.createByName}</span></div>
                      </div>
                      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <div style={{ cursor: 'pointer', background: '#48ab42', color: '#fff', borderRadius: '5px', padding: '0 5px', marginRight: '5px', display: item.pay_states === 0 || item.pay_states === 1 ? 'block' : 'none' }} onClick={(e) => sendAnOrder(e, item.trade_sn)}>发送订单</div>
                        <div style={{ cursor: 'pointer', background: 'red', color: '#fff', borderRadius: '5px', padding: '0 5px', marginRight: '5px', display: item.pay_states === 0 || item.pay_states === 1 ? 'block' : 'none' }} onClick={(e) => DelOrder(e, item.trade_sn, item.combo_name)}>删除订单</div>
                        <div style={{ cursor: 'pointer', background: 'red', color: '#fff', borderRadius: '5px', padding: '0 5px', display: item.pay_states === 0 ? 'block' : 'none', marginRight: '5px' }} onClick={(e) => offlinePayment(e, item)} >修改订单</div>
                        <div style={{ cursor: 'pointer', background: '#48ab42', color: '#fff', borderRadius: '5px', padding: '0 5px', display: item.pay_states === 1 ? 'block' : 'none' }} onClick={(e) => refund_(e, item.trade_sn)}>退款</div>
                      </div>
                    </div>
                  ))
                  :
                  (<div>暂无订单记录</div>)
              }
            </div>
          </div>
          <div style={{ display: isqywxguardian ? 'block' : 'none', marginBottom: '10px', background: '#fafafb', borderRadius: '5px', padding: '5px' }}>
            <div style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>选片记录</div>
            <div style={{ maxHeight: '400px', overflowY: 'scroll', width: '100%', display: 'flex', flexDirection: 'column' }}>
              {
                selectionRecord && selectionRecord.length > 0 ?
                  selectionRecord.map((item: any, index: any) => (
                    <div key={index} style={{ marginBottom: '10px', background: '#fff', width: '100%', padding: '2px 0', cursor: 'pointer', display: 'flex', flexDirection: 'column' }}>
                      <div style={{ width: '100%', overflow: 'hidden' }}>选片师：{item.photoSelector}</div>
                      <div style={{ width: '100%', overflow: 'hidden' }}>选片时间：{item.selectTime}</div>
                      <div style={{ width: '100%', overflow: 'hidden' }}>学生姓名：{item.studentName}</div>
                      <div style={{ width: '100%', overflow: 'hidden', display: item.selectDuration ? 'block' : 'none' }}>选片时长：{item.selectDuration}</div>
                      {/* <div style={{ width: '100%', overflow: 'hidden', display: item.recordUrl ? 'block' : 'none' }}>录音地址：{item.recordUrl}</div> */}
                      <div style={{ width: '100%', overflow: 'hidden' }}>
                        选片录音：
                        <div style={{ display: item.recordUrl ? 'inline-block' : 'none', padding: '0 5px', textAlign: 'center', border: '1px solid #000' }} onClick={() => { handleCopyKey(item.recordUrl) }}>复制</div>
                        <div style={{ display: item.recordUrl ? 'none' : 'inline-block', padding: '0 5px', textAlign: 'center', border: '1px solid #000' }} onClick={() => { getRecording(item) }}>获取录音</div>
                      </div>
                      <div style={{ width: '100%', overflow: 'hidden', display: item.thisStatus ? 'block' : 'none' }}>选片状态：<span style={{ color: 'red' }}>{item.thisStatus}</span></div>
                      <div style={{ width: '100%', overflow: 'hidden' }}>备注：<span style={{ color: 'red' }}>{item.selectNote}</span><span style={{ textDecoration: 'underline', marginLeft: '5px', color: 'rgb(72, 171, 66)', marginRight: '5px' }} onClick={(e) => modify(e, item)}>修改</span></div>
                    </div>
                  ))
                  :
                  (<div>暂无选片记录</div>)
              }
            </div>
          </div>
        </div >
      </div >
    </Spin >
  )
}

export default Home;
